import { render, staticRenderFns } from "./DependentPressVisa.vue?vue&type=template&id=1b2cf7cb&"
import script from "./DependentPressVisa.vue?vue&type=script&lang=js&"
export * from "./DependentPressVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports